/* eslint-disable max-len */
import React, { useEffect } from 'react';
import {
  CContainer,
  CRow,
  CCol,
  CCard,
  CCardBody,
  CCardHeader,
  CBreadcrumb,
  CBreadcrumbItem,
} from '@coreui/react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import MaterialInputs from '../../components/MaterialInputs/MaterialInputs';
import { connect } from 'react-redux';
import { updateMaterialRequestAction } from '../../store/material/materialActions';
import { useTranslation } from '../../hooks/useTranslation';

const UpdateMaterial = ({ updateMaterialRequest, isLoading, updateMaterialData }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const materialData = location.state?.material || null;
  const { t } = useTranslation();

  useEffect(() => {
    if (!materialData && id) {
      console.warn('No material data found in route state. You may need to fetch by ID:', id);
    }
  }, [materialData, id]);

  const handleMaterialSubmit = (materialData) => {
    updateMaterialRequest({ data: materialData, navigate });
  };

  const handleBackToList = () => {
    navigate('/material');
  };

  return (
    <CContainer>
      <CBreadcrumb className="mb-4">
        <CBreadcrumbItem href="#/material" onClick={(e) => { e.preventDefault(); handleBackToList(); }}>
          {t('material')}
        </CBreadcrumbItem>
        <CBreadcrumbItem active>{t('edit')}</CBreadcrumbItem>
      </CBreadcrumb>

      <CRow>
        <CCol xs={12}>
          <CCard>
            <CCardHeader>
              <div className="d-flex justify-content-between align-items-center">
                <h4 className="mb-0">{t('edit')}</h4>
                {materialData?.MaterialId && (
                  <small className="text-muted">ID: {materialData.MaterialId}</small>
                )}
              </div>
            </CCardHeader>
            <CCardBody>
              {materialData ? (
                <MaterialInputs
                  onSubmit={handleMaterialSubmit}
                  onCancel={handleBackToList}
                  isLoading={isLoading}
                  submitResponse={updateMaterialData}
                  initialData={materialData}
                  isEdit={true}
                />
              ) : (
                <div className="text-center py-4">
                  <div className="text-muted">
                    {t('noDataFound')}
                  </div>
                  <button className="btn btn-primary mt-3" onClick={handleBackToList}>
                    {t('back')}
                  </button>
                </div>
              )}
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  );
};

const mapStateToProps = (state) => ({
  updateMaterialData: state.materialReducer.updateMaterialData,
  isLoading: state.loadingReducer.isLoading,
});

const mapDispatchToProps = (dispatch) => ({
  updateMaterialRequest: (payload) => dispatch(updateMaterialRequestAction(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UpdateMaterial);
